import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import img from '../../assets/img/brand/goodybuddy_short.png';
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const BuddyInformation = ({ experience }) => {
  const navigate = useNavigate();

  return (
    <Row className="justify-content-center align-items-stretch">
      {/* Left Card: Profile Image */}
      <Col md="4" sm="12" className="d-flex">
        <Card className="shadow flex-fill">
          <CardBody className="d-flex flex-column align-items-center justify-content-center">
            <img
              src={experience?.hostedBy?.profileImage || img}
              alt={`${experience?.hostedBy?.firstName} ${experience?.hostedBy?.lastName}`}
              className="rounded-circle mb-3 object-cover object-center"
              width="150"
              height="150"
            />
            <CardTitle tag="h2">
              {experience?.hostedBy?.firstName} {experience?.hostedBy?.lastName}
            </CardTitle>
          </CardBody>
        </Card>
      </Col>

      {/* Right Card: Details */}
      <Col md="8" sm="12" className="d-flex">
        <Card className="shadow flex-fill">
          <CardBody>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Email:</strong></Col>
              <Col md="8" sm="8">{experience?.hostedBy?.email}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Mobile:</strong></Col>
              <Col md="8" sm="8">{experience?.hostedBy?.mobileNo}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Date of Birth:</strong></Col>
              <Col md="8" sm="8">{new Date(experience?.hostedBy?.dob).toLocaleDateString('en-GB')}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Account Created On:</strong></Col>
              <Col md="8" sm="8">{new Date(experience?.hostedBy?.createdAt).toLocaleDateString('en-GB')}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Type:</strong></Col>
              <Col md="8" sm="8">Buddy</Col>
            </Row>
            <div className="text-center mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <BackButton />
                <AddButton title='More Info' onClick={() => navigate('/admin/user/view/' + experience?.hostedBy?._id)} />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default BuddyInformation;
